import React from 'react'

import theme from 'theme'

import Text, { type TextProps } from './Text'

type AlertVariation = 'base' | 'green' | 'yellow' | 'red'

export const COLOR_MAP = {
  base: {
    '--borderColor': theme.colors.border[0],
    '--backgroundColor': theme.colors.panel[0],
    '--iconColor': theme.colors.steel[1]
  },
  green: {
    '--borderColor': theme.colors.green[0],
    '--backgroundColor': theme.colors.green[0],
    '--iconColor': theme.colors.white[0]
  },
  yellow: {
    '--borderColor': theme.colors.yellow[1],
    '--backgroundColor': theme.colors.yellow[1],
    '--iconColor': theme.colors.white[0]
  },
  red: {
    '--borderColor': theme.colors.red[0],
    '--backgroundColor': theme.colors.red[0],
    '--iconColor': theme.colors.white[0]
  },
  orange: {
    '--borderColor': theme.colors.orange[0],
    '--backgroundColor': theme.colors.orange[0],
    '--iconColor': theme.colors.white[0]
  }
}

type AlertProps = {
  variation?: AlertVariation
  children: React.ReactNode
}

export const Alert = React.forwardRef<
  HTMLDivElement,
  AlertProps & React.HTMLProps<HTMLDivElement>
>(({ variation, ...rest }, ref) => {
  return (
    <div
      ref={ref}
      css={{
        ...COLOR_MAP[variation],
        display: 'grid',
        gridTemplateColumns: 'max-content auto max-content',
        background: theme.colors.white[0],
        border: theme.border.base,
        borderColor: 'var(--borderColor)',
        borderRadius: theme.borderRadius[0]
      }}
      {...rest}
    />
  )
})

Alert.displayName = 'Alert'

export const AlertIcon: React.FC = (props) => {
  return (
    <div
      css={{
        display: 'grid',
        padding: theme.space[3],
        placeContent: 'center',
        color: 'var(--iconColor)',
        fontSize: theme.fontSizes[4],
        backgroundColor: 'var(--backgroundColor)',
        borderTopLeftRadius: theme.borderRadius[0],
        borderBottomLeftRadius: theme.borderRadius[0]
      }}
      {...props}
    />
  )
}

export const AlertContent: React.FC = (props) => {
  return (
    <div
      css={{
        display: 'grid',
        gap: theme.space[2],
        padding: theme.space[3],
        backgroundColor: theme.colors.white[0],
        borderTopRightRadius: theme.borderRadius[0],
        borderBottomRightRadius: theme.borderRadius[0],
        overflow: 'hidden',
        wordBreak: 'break-word'
      }}
      {...props}
    />
  )
}

export const AlertTitle: React.FC<TextProps> = (props) => {
  return <Text as="h4" color="medium" {...props} />
}

export const AlertText: React.FC<TextProps> = (props) => {
  return <Text as="p" color="medium" {...props} />
}

export const AlertAction: React.FC = (props) => {
  return (
    <div
      css={{
        display: 'grid',
        justifySelf: 'center',
        alignSelf: 'center',
        gap: theme.space[2],
        paddingLeft: theme.space[4],
        paddingRight: theme.space[4]
      }}
      {...props}
    />
  )
}
